import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { supabase } from '../../services/supabaseClient';
import './Auth.css';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setError('');

    try {
      const loggedInUser = await login(email, password);
      console.log('➡️ received in LoginPage:', loggedInUser);

      // Fetch user profile to check account status
      const { data: profile, error: profileError } = await supabase
        .from('users')
        .select('status')
        .eq('auth_id', loggedInUser.id)
        .single();

      if (profileError) {
        console.error('⚠️ Error fetching user profile:', profileError.message);
      } else {
        const status = profile?.status || 'active';
        console.log('👀 User status:', status);

        if (status === 'past_due') {
          navigate('/account-status?type=past_due', { replace: true });
          return;
        }
        if (status === 'inactive') {
          navigate('/account-status?type=inactive', { replace: true });
          return;
        }
        if (status === 'new') {
          navigate('/welcome', { replace: true });
          return;
        }
      }

      // Send to home — let ProtectedRoute handle final routing
      navigate('/', { replace: true });
    } catch (err) {
      const message =
        err instanceof Error ? err.message : 'Unknown login error';
      console.error('❌ Login error:', message);
      setError('Invalid email or password');
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Welcome Back</h2>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="auth-button">
            Log In
          </button>
        </form>
        <p className="auth-link">
          Forgot password? <Link to="/forgot-password">Reset</Link>
        </p>
        <p className="auth-link">
          Don't have an account? <Link to="/register">Sign up</Link>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;

